import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  PROFILE_MGMT,
  SECURITY_QUESTIONS_MGMT,
  SECURITY_QUESTIONS,
  MISSING_QUESTIONS,
  CONFIG,
  CONFIGS,
  DEFAULT_QUESTIONS,
  REQUEST_STATE,
  ORIGINAL_SECURITY_QUESTIONS,
} = STATE_IDENTIFIER;

const emptyState = {
  [PROFILE_MGMT]: "",
  [SECURITY_QUESTIONS_MGMT]: {
    [SECURITY_QUESTIONS]: null,
    [ORIGINAL_SECURITY_QUESTIONS]: null,
    [CONFIG]: {
      [MISSING_QUESTIONS]: null,
      [CONFIGS]: [],
      [DEFAULT_QUESTIONS]: [],
    },
    [REQUEST_STATE]: IResponseState.PENDING,
  },
};

export default emptyState;
